export const DEFAULT_CHAT_LANGUAGE = "en";
export const languages = [
    { code: "en", name: "English" },
    { code: "ar", name: "Arabic" },
    { code: "zh", name: "Chinese" },
    { code: "de", name: "German" },
    { code: "es", name: "Spanish" },
    { code: "fr", name: "French" },
    { code: "hi", name: "Hindi" },
    { code: "it", name: "Italian" },
    { code: "ja", name: "Japanese" },
    { code: "ko", name: "Korean" },
    { code: "pl", name: "Polish" },
    { code: "pt", name: "Portuguese" },
    { code: "ru", name: "Russian" },
    { code: "tr", name: "Turkish" },
];
export const PREFERRED_CHAT_LANGUAGE_CODES = languages.map((language) => language.code);
export const definitions = [
    { code: "minimal", name: "Minimal" },
    { code: "low", name: "Low" },
    { code: "mid", name: "Mid" },
    { code: "high", name: "High" },
    { code: "very", name: "Very" },
];
